import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadStripe } from '@stripe/stripe-js/pure';
import { Elements } from '@stripe/react-stripe-js';
import { RG, SD } from '../../../../../../utils/constants';
import unexpectedErrorMessage from '../../../../../../utils/unexpectedErrorMessage';
import { getStripePublishableKey } from '../../../../../../utils/payments';
import { getBillingDetailsSelector } from '../../../../../../utils/selectors';
import CreditCardStripeForm, {
  completeCardPayment,
} from '../../../../../02_molecules/CreditCardStripeForm';
import {
  donationFormPaymentSuccess,
  donationFormSubmitError,
  donationFormUnLock,
} from '../../../../../../store/Slices/cnet/donationFormSlice';

const stripePromise = loadStripe(getStripePublishableKey());

const DonationCreditCardStripe = ({
  billingDetails,
  orderID = null,
  donationType,
  captchaToken = '',
  dispatch = () => {},
}) => {
  return (
    <Elements
      stripe={stripePromise}
      options={{
        fonts: [
          {
            cssSrc: 'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans',
          },
        ],
      }}
    >
      <CreditCardStripeForm
        orderId={orderID}
        onCompleteCardPayment={async (stripe, elements) => {
          const result = await completeCardPayment(
            stripe,
            elements,
            billingDetails,
            orderID,
            donationType,
            captchaToken,
          );
          if (result.type === 'error') {
            // Show message to the user.
            dispatch(
              donationFormSubmitError({
                errorMessage: 'Sorry, we could not submit your donation.',
                subline: unexpectedErrorMessage(),
                additionalMessage: result.errorMessage,
              }),
            );
          } else {
            dispatch(donationFormPaymentSuccess(orderID));
          }
          dispatch(donationFormUnLock());
        }}
      />
    </Elements>
  );
};

DonationCreditCardStripe.propTypes = {
  billingDetails: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  orderID: PropTypes.number,
  donationType: PropTypes.oneOf([SD, RG]).isRequired,
  dispatch: PropTypes.func,
  captchaToken: PropTypes.string,
};

const mapStateToProps = ({ donationForm: { form, orderID } }) => ({
  orderID,
  donationType: form.values.type,
  billingDetails: getBillingDetailsSelector(form),
  captchaToken: form.values.captcha_token,
});

export default connect(mapStateToProps)(DonationCreditCardStripe);
